module.exports = __webpack_public_path__ + "static/nievre-bc75f1541258e2455dcb046496caed19.png";